interface RegistrationModalCookie {
    pageLoadedCounter: number
    modalShown: boolean
}

export default () => {
    return useCookie<RegistrationModalCookie>('registrationModal', {
        maxAge: 2592000, // 30 days
        secure: true,
        default() {
            return {
                pageLoadedCounter: 0,
                modalShown: false,
            }
        },
    })
}

/**
 * Removes the `registrationModal` cookie. Called when functionality consent is revoked —
 * it is a functional (non-essential) cookie, so it must not linger without consent.
 */
export function clearRegistrationModalCookie(): void {
    useCookie('registrationModal').value = null
}
